import { render, staticRenderFns } from "./SearchItemInfo.vue?vue&type=template&id=21b99d76&scoped=true&"
import script from "./SearchItemInfo.vue?vue&type=script&lang=js&"
export * from "./SearchItemInfo.vue?vue&type=script&lang=js&"
import style0 from "./SearchItemInfo.vue?vue&type=style&index=0&id=21b99d76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b99d76",
  null
  
)

export default component.exports